import LoaderMUI from './LoaderMUI';

export default LoaderMUI;
